import { Field } from 'redux-form';
import { Checkbox } from '@amo/core/components/forms';

const RecapGPTConsent = ({ consentError, typeMER }) => (
    <div className={'row justify-content-center'}>
        <div className={'col-12 col-lg-8 mb-2 mt-3'}>
            <Field name="gptConsent" component={Checkbox} type="checkbox">
                <p className={'cursor-pointer'}>
                    Je confirme que les informations ci-dessus, collectées lors de ma conversation
                    avec {typeMER === 'AgentConv' ? "l'agent conversationnel" : "l'assistant ChatGPT"}, sont exactes
                    et j'autorise leur utilisation pour l'établissement de mon devis d'assurance.
                    <sup className="text-danger">*</sup>
                </p>
            </Field>
            {consentError && (
                <p className="text-danger f-12 mt-1 mb-0">
                    Veuillez cocher cette case pour continuer.
                </p>
            )}
        </div>
    </div>
);

export default RecapGPTConsent;
